import AppointmentOverviewContainer from "../../container/appointmentOverview/appointmentOverviewContainer";
import AppointmentOverviewContext from "../../container/appointmentOverview/context/appointmentOverviewContext";

const AppointmentOverview = (): React.JSX.Element => (
  <AppointmentOverviewContext>
    <AppointmentOverviewContainer />
  </AppointmentOverviewContext>
);

export default AppointmentOverview;
